//Module Keys
let locales = {
    dashboardPanel_title: "DASHBOARD",
    dashboardPanel_mutiple_title: "DASHBOARDS",
    dashboardPanel_preview: "Preview",
    dashboardPanel_add_gadget: "Add gadget",
    dashboardPanel_edit_gadget: "Edit gadget ",
    dashboardPanel_edit_info: "Right now, you are editing your dashboard. The changes will be saved automatically.",
    dashboardPanel_edit_frequency: "Frequency Refresh",
    dashboardPanel_edit_title: "Title",
    dashboardPanel_edit_minutes: "Minutes",
    dashboardPanel_edit_hours: "Hours",
    dashboardPanel_edit_days: "Days",
    dashboardPanel_edit_report_type: "Report Type",
    dashboardPanel_edit_chart_type: "Chart Type",
    dashboardPanel_edit_groups_unit: "Tags/Units",
    dashboardPanel_edit_time_metric: "Time Metric",
    dashboardPanel_edit_IdleTime:'Idle Time',
    dashboardPanel_edit_IdleStop:'Idle Stop',
    dashboardPanel_edit_DriveTime:'Driver time',
    dashboardPanel_edit_DriverStop:'Stop Time',
    dashboardPanel_edit_Speeding:'Speeding',
    dashboardPanel_edit_Mileage:'Mileage',
    dashboardPanel_edit_EngineTime:'Engine Time',
    dashboardPanel_edit_DriverOverview:'Driving Overview',
    dashboardPanel_edit_DriverSafety:'Driver Safety',
    dashboardPanel_edit_allUnits:'All Units',
    dashboardPanel_edit_singleGroup:'Single Tag',
    dashboardPanel_edit_compareGroup:'Compare Tags',
    dashboardPanel_edit_month:'Month',
    dashboardPanel_edit_week:'Week',
    dashboardPanel_edit_quarter:'Quarter',
    dashboardPanel_edit_chart_pie:'Pie',
    dashboardPanel_edit_chart_bar:'Column',
    dashboardPanel_edit_device_offline:'Offline Devices',
    dashboardPanel_edit_chart:'Charts',
    dashboardPanel_edit_fleet:"Device Category",
    dashboardPanel_offline_thresholdMinutes:"Time threshold",
    dashboardPanel_edit_group: "Group",
    dashboardPanel_edit_tag: "Tag",
    dashboardPanel_edit_title_chart:'Chart',
    dashboardPanel_edit_view:'View',
    dashboardPanel_edit_percentage:'As Percentage',
    dashboardPanel_name: "Dashboard Name",
    dashboardPanel_rename: "Rename Dashboard",
    dashboardPanel_delete: "Delete Dashboard",
    dashboardPanel_title_new: "New Dashboard",
    dashboardPanel_title_edit: "Edit Dashboard",
    dashboardPanel_chart_label_Mon: "Mon",
    dashboardPanel_chart_label_Tue: "Tue",
    dashboardPanel_chart_label_Wed: "Wed",
    dashboardPanel_chart_label_Thu: "Thu",
    dashboardPanel_chart_label_Fri: "Fri",
    dashboardPanel_chart_label_Sat: "Sat",
    dashboardPanel_chart_label_Sun: "Sun",    
    dashboardPanel_chart_label_Jan: "Jan",    
    dashboardPanel_chart_label_Feb: "Feb",  
    dashboardPanel_chart_label_Mar: "Mar",
    dashboardPanel_chart_label_Apr: "Apr",
    dashboardPanel_chart_label_May: "May",
    dashboardPanel_chart_label_Jun: "Jun",
    dashboardPanel_chart_label_Jul: "Jul",
    dashboardPanel_chart_label_Aug: "Aug",
    dashboardPanel_chart_label_Sep: "Sep",
    dashboardPanel_chart_label_Oct: "Oct",
    dashboardPanel_chart_label_Nov: "Nov",
    dashboardPanel_chart_label_Dec: "Dec",
    dashboardPanel_to: "to",
};

//Merge Views
import main from 'Modules/accounts/views/main/lan/en';
import overview from 'Modules/accounts/views/overview/lan/en';
import purgeAccount from 'Modules/accounts/views/components/purgeAccount/lan/en';
import createAccount from 'Modules/accounts/views/components/createEditAccount/lan/en';
import changeStatusAccount from 'Modules/accounts/views/components/changeStatus/lan/en';
import resetCompanyAuthentication from 'Modules/accounts/views/components/resetCompanyAuthentication/lan/en';
import systemAlertLogsTab from 'Modules/accounts/.components/systemAlertLogsTab/lan/en';
import scheduledReports from 'Modules/accounts/.components/scheduledReports/lan/en';
import exportLogs from 'Modules/accounts/.components/exportLogs/lan/en';
import reprocessOdoHours from 'Modules/accounts/.components/reprocessOdoHours/lan/en';
import changeUsername from 'Modules/accounts/.components/changeUsername/lan/en';
import tabAccounts from 'Modules/accounts/.components/tab/lan/en';
import promilesRequest from 'Modules/accounts/views/components/promilesRequest/lan/en';
import tabIntegrations from 'Modules/accounts/.components/tabIntegrations/lan/en';
import addIntegration from 'Modules/accounts/.components/addIntegration/lan/en';
import viewCerebrumXIntegration from 'Modules/accounts/.components/viewCerebrumXIntegration/lan/en';
import addCerebrumXOEM from 'Modules/accounts/.components/addCerebrumXOEM/lan/en';
import deleteCerebrumXIntegration from 'Modules/accounts/.components/deleteCerebrumXIntegration/lan/en';
import syncEntities from 'Modules/accounts/views/components/syncEntities/lan/en';
import edgeTensor from 'Modules/accounts/.components/tabEdgeTensor/lan/en';
import edgeTensorVideoReview from 'Modules/accounts/.components/edgeTensorVideoReview/lan/en';
import tabApiKeys from 'Modules/accounts/.components/tabApiKeys/lan/en';

locales = {
    ...locales,
    ...main,
    ...overview,
    ...purgeAccount,
    ...createAccount,
    ...changeStatusAccount,
    ...resetCompanyAuthentication,
    ...systemAlertLogsTab,
    ...scheduledReports,
    ...exportLogs,
    ...reprocessOdoHours,
    ...changeUsername,
    ...tabAccounts,
    ...promilesRequest,
    ...tabIntegrations,
    ...addIntegration,
    ...viewCerebrumXIntegration,
    ...addCerebrumXOEM,
    ...deleteCerebrumXIntegration,
    ...syncEntities,
    ...edgeTensor,
    ...edgeTensorVideoReview,
    ...tabApiKeys
};


export default locales;